import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SideModal from "/src/components/modal/SideModal/SideModal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";

import BrainModalBody from "./BrainModalBody";

const BrainModal = NiceModal.create(({ title, data, llms }) => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
    const form = { title: title, data: data ? data : {} };

    return (
        <SideModal name="add-brain" id={modal.id} autoClose="true" onClose={onClose}>
            <div>
                <div
                    className="button-leave"
                    id="close_modal_container"
                    onClick={() => onClose({ idIconModal: "close_modal_container" })}>
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>

            <BrainModalBody form={form}></BrainModalBody>
        </SideModal>
    );
});

export default BrainModal;
